import { CommonModule } from '@angular/common';
import { Component, input, model, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';
import { CustomCurrencyPipe } from "../../pipe/custom-currency.pipe";
import { PaymentType } from '../../models/paymentData';
import { MatIconModule } from '@angular/material/icon';
import { PaymentInvoiceModalData, PaymentInvoiceModalComponent } from '../payment-invoice-modal/payment-invoice-modal.component';

declare var bootstrap: any;

@Component({
  selector: 'app-choose-payment-modal',
  standalone: true,
  imports: [CommonModule, CustomCurrencyPipe, MatIconModule, PaymentInvoiceModalComponent],
  templateUrl: './app-choose-payment-modal.component.html',
  styleUrl: './app-choose-payment-modal.component.scss'
})
export class AppChoosePaymentModalComponent implements OnInit, OnDestroy {
  modalId = input.required<string>();
  modalTitle = input.required<string>();
  modalData = input.required<any>();
  size = input<string>('none');

  confirmAction = model();

  paymentModalId = 'payment-modal';
  PaymentType = PaymentType;
  paymentType: PaymentType;
  paymentInvoiceModalData: PaymentInvoiceModalData;
  modalInstance: any;
  invoice: any;

  private modalSubscription: Subscription | undefined;

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
    this.modalSubscription = this.modalService.modalState$.subscribe((state) => {
      if (state.id === this.modalId()) {
        const modalElement = document.getElementById(state.id);
        if (modalElement) {
          if (state.action === 'open') {
            this.modalInstance = new bootstrap.Modal(modalElement); // Instanciando o modal
            this.modalInstance.show();
            setTimeout(() => {
              this.invoice = this.modalData()?.invoice;
            }, 200);
          } else if (state.action === 'close') {
            if (this.modalInstance) {
              this.modalInstance.hide();
            }
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  openModal(paymentType: PaymentType) {
    this.paymentInvoiceModalData = { invoiceId: this.invoice.id, invoiceAmount: this.invoice.amount || 0 };
    this.paymentType = paymentType;
    setTimeout(() => {
      this.modalService.open(this.paymentModalId);
    }, 100);
  }

  onCancel() {
    this.modalInstance.hide();
  }

  onModalConfirm(event: boolean) {
    if (event) {
      this.confirmAction.set(this.modalData().checkin);
      this.modalInstance.hide();
    }
  }
}
